import router from "./basa/router";
import store from "./config/store";
// import { getAppToken } from "./config/api/login";
import { getArgs } from "@/basa/utils";
import Cookies from "js-cookie";
import { addUrlPerFix } from "./basa/utils";
import homepage from "./config/mock/homepage";

let menu, timer;
store.commit("SET_OPENFLAG", false);

function parseJson(arr) {
  if (arr.length !== 0) {
    var pp = function(arr) {
      for (var i = 0; i < arr.length; i++) {
        arr[i].meta = {};
        arr[i].menuCode = arr[i].keyword;
        arr[i].meta.isShowSideBar = arr[i].showLeftMenu === 1;
        arr[i].isShowSideBar = arr[i].showLeftMenu === 1;
        if (arr[i].sons && arr[i].sons.length !== 0) {
          arr[i].subMenu = arr[i].sons;
          // // console.log(arr[i].name); // 这里可以写菜单的样式结构...
          pp(arr[i].sons);
        } else {
          // // console.log(arr[i].name); // 这里可以写菜单的样式结构...
          arr[i].meta.isShowSideBar = arr[i].showLeftMenu === 1;
          arr[i].isShowSideBar = arr[i].showLeftMenu === 1;
        }
      }
    };
    pp(arr);
  }
  menu = arr;
  // console.log('menu1', menu.length);
}

router.beforeEach(async (to, from, next) => {
  // 获取AppToken start
  // 开发环境加localhost加临时access_token防止无限重定向登录
  if (window.location.hostname === "localhost") {
    Cookies.set("access_token", "6490c52ed1c547d796cdef6bac46d78c");
  }

  function goLogin() {
    window.location.href =
      addUrlPerFix(process.env.VUE_APP_LOGIN) +
      "?redirectUrl=" +
      encodeURIComponent(window.location.href);
  }

  function getTimer() {
    return setInterval(function() {
      if (!Cookies.get("access_token")) {
        setTimeout(function() {
          goLogin();
        }, 800);
      }
    }, 1000);
  }

  if (Cookies.get("access_token")) {
    store.commit("SET_ACCESS_TOKEN", Cookies.get("access_token"));
    // 缓存有accessToken，开始检测
    timer = timer || getTimer();
    // if (to.query.CODE) {
    //   if (localStorage.appToken === undefined) {
    //     let res = await getAppToken({
    //       code: to.query.CODE,
    //       client_id: to.query.a
    //     });
    //     if (res.data.code === "0") {
    //       // 缓存apptoken
    //       localStorage.appToken = res.data.message;
    //       store.commit("SET_APP_TOKEN", localStorage.appToken);
    //       timer =
    //         timer ||
    //         setInterval(function() {
    //           if (!Cookies.get("access_token")) {
    //             window.location.href =
    //               addUrlPerFix(process.env.VUE_APP_LOGIN) +
    //               "?redirectUrl=" +
    //               encodeURIComponent(window.location.href);
    //           }
    //         }, 1000);
    //     } else if (res.data.code === "111") {
    //       // 失效时删除缓存的apptoken和accessToken
    //       localStorage.removeItem("appToken");
    //       goLogin();
    //     } else if (res.data.code === "305" || res.data.code === "307") {
    //       // 无权限（agentId是错的305—）或没有agentId307
    //       counter++;
    //       store.dispatch("setRouter305", {
    //         isShow: true,
    //         message: res.data.message
    //       });
    //       next({
    //         replace: true,
    //         path: `/305?a=${getArgs("a")}`
    //       });
    //       return;
    //     }
    //   } else {
    //     store.commit("SET_APP_TOKEN", localStorage.appToken);
    //   }
    // } else {
    //   if (localStorage.appToken === undefined) {
    //     // // console.log(to.query.a);
    //     // 走OAuth流程
    //     if (counter === 0) {
    //       window.location.href =
    //         addUrlPerFix(process.env.VUE_APP_OAUTH_URL) +
    //         "?CLIENT_ID=" +
    //         to.query.a +
    //         "&CALLBACK_URL=" +
    //         encodeURIComponent(window.location.href);
    //     }
    //   } else {
    //     store.commit("SET_APP_TOKEN", localStorage.appToken);
    //   }
    // }
  } else {
    // Cookies里也没有ACCESS_TOKEN,跳登录页
    goLogin();
  }

  // 获取AppToken end

  if (store.state.app.routerPower.isShow) {
    next();
    return;
  }

  // console.log('menu2', store.state.app.menu.length)
  if (!store.state.app.menu.length) {
    // await sleep(500)
    let res = {};
    res.data = {
      data: {
        root: {
          showLeftMenu: null,
          code: "root",
          auth: false,
          pcode: "",
          auths: [],
          type: null,
          url: "",
          viewTemplate: "",
          sons: [
            // begin
            ...homepage
          ],
          name: "",
          id: null,
          isGroup: null,
          keyword: ""
        }
      },
      code: "0",
      message: "success"
    };

    if (res && res.data.code === "0") {
      const arr = res.data.data.root.sons;
      arr.forEach(item => {
        item.pid = "1";
        item.id = 1 + "-" + item.code;
        if (item.sons && item.sons.length) {
          item.sons.forEach(item2 => {
            item2.pid = item.id;
            item2.id = item.id + "-" + item2.code;
            if (item2.sons && item2.sons.length) {
              item2.sons.forEach(item3 => {
                item3.pid = item2.id;
                item3.id = item2.id + "-" + item3.code;
                if (item3.sons && item3.sons.length) {
                  item3.sons.forEach(item4 => {
                    item4.pid = item3.id;
                    item4.id = item3.id + "-" + item4.code;
                  });
                }
              });
            }
          });
        }
      });
      // console.log('menu arr',arr)
      parseJson(arr);
      const routeObj = JSON.parse(JSON.stringify(arr));
      // console.log('menu4',routeObj)
      store.dispatch("generateRoutes", routeObj).then(() => {
        console.log("menu", store.getters.addRouters);
        router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
        router.addRoutes([
          {
            path: "",
            redirect: store.getters.addRouters[0].path
          }
        ]);
        console.log("to", to);
        next({
          ...to,
          replace: true
        }); // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
      });
      // menu.splice(menu.length - 1, 1)
      store.dispatch("setMenu", menu);
      // console.log('menu3',menu)

      const loadingOverlay = document.querySelector(".loading-overlay");
      loadingOverlay && (loadingOverlay.style.display = "none");
    }
  }

  if (to.name) {
    // 是否隐藏三级菜单
    if (to.meta.isShowSidebar) {
      store.dispatch("openSidebarTemporary");
    } else {
      store.dispatch("closeSidebarTemporary");
    }
  }
  if (to.query.a) {
    next();
  } else {
    let query = to.query;
    query.a = getArgs("a");
    if (!query.a) {
      next();
    } else {
      next({
        path: to.path,
        query: query
      });
    }
  }
});

// function sleep(ms) {
//   return new Promise(resolve => setTimeout(resolve, ms));
// }
